import React from 'react';
import HeroSection from '../components/sections/HeroSection';
import ServicesSection from '../components/sections/ServicesSection';
import WhyUsSection from '../components/sections/WhyUsSection';
import TestimonialsSection from '../components/sections/TestimonialsSection';
import ProcessSection from '../components/sections/ProcessSection';
import ContactSection from '../components/sections/ContactSection';
import CTABanner from '../components/sections/CTABanner';

const Home = () => (
  <div className="animate-fade-in">
    <HeroSection />
    <ServicesSection />
    <WhyUsSection />
    <ProcessSection />
    <TestimonialsSection />
    <CTABanner />
    <ContactSection />
  </div>
);

export default Home;
